module.exports = __webpack_public_path__ + "img/icon-setting.9bc24158.png";